import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=7b77b7a7&scoped=true"
import script from "./Scopes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Scopes.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b77b7a7",
  null
  
)

export default component.exports